import * as THREE from 'three';
import { Base3DPart } from "./base-part";

export class Schede3DPart extends Base3DPart {

    private position: number;
    private offset: THREE.Vector3;
    private _type: string;

    constructor(position: number, type: string) {
        let offset = new THREE.Vector3(0, position * 5, 0);
        if (type === 'Hyperion') {
            offset = new THREE.Vector3(0, position * 4.8, 0);
        } else if (type === 'Optica') {
            offset = new THREE.Vector3(0, position * 3.9, 0);
        }
        super(type, true);
        this.offset = offset;
        this.position = position;
        this._type = type;
    }

    override load(scene: THREE.Scene): void {
        const objPath = `${this.basePath}/schede/scheda.gltf`;

        this.gltfLoader.load(objPath, (gltf) => {
            gltf.scene.position.add(this.offset);
            scene.add(gltf.scene);
        });
    }
}